import React from 'react'

import { isEmpty } from 'lodash'

import { TableContainer } from '@material-ui/core'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'

const EntitiesTable = ({ entities }) => {
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell width="20%">Nome</TableCell>
            <TableCell width="80%">Descrição</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isEmpty(entities) && (
            <TableRow>
              <TableCell colSpan={2}>Nenhum registro encontrado.</TableCell>
            </TableRow>
          )}
          {entities.map((entity) => (
            <TableRow key={entity?.id}>
              <TableCell>{entity?.name}</TableCell>
              <TableCell>{entity?.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default EntitiesTable
